import { ChevronDown, ChevronRight } from "lucide-react";

import { IconButton } from "@/components/ui/icon-button";
import { cn } from "@/lib/utils";

export interface RowExpanderButtonProps {
  expanded: boolean;
  onToggle: () => void;
  /** Names what expands, e.g. "Measurement breakdown for F-01". State comes from `aria-expanded`. */
  label: string;
  disabled?: boolean;
  className?: string;
}

/** Expand/collapse control for nested rows in the viewers' results tables. */
export function RowExpanderButton({
  expanded,
  onToggle,
  label,
  disabled,
  className,
}: RowExpanderButtonProps) {
  return (
    <IconButton
      label={label}
      icon={expanded ? ChevronDown : ChevronRight}
      size="xs"
      variant="outline"
      aria-expanded={expanded}
      disabled={disabled}
      className={cn("shadow-none", className)}
      onClick={onToggle}
    />
  );
}

/** Placeholder that keeps names aligned in rows without children. */
export function RowExpanderSpacer() {
  return <span className="size-6 shrink-0" aria-hidden="true" />;
}
